import { AuthProvider } from "react-oidc-context";
import { AppConfigService } from '@kf-react/config';
import { App } from '../App';
import { WebStorageStateStore } from 'oidc-client-ts';
import { useMemo } from 'react';
import { type  ApplicationConfig } from "@/core/domain/app.config";
import i18n from '@/i18n/i18n';


export function SecurityProvider() {
  const auth = AppConfigService.getInstance<ApplicationConfig>()?.config?.auth;
  // const realm = useRealmStore((state) => state.realm);

  if (!auth) return <div>Cargando configuración...</div>;

  // Siempre usa realm de customer (autor comentado)
  const realmValue = auth.realm;
  // const realmValue = realm === "author" ? auth.realmAuthor : auth.realm;

  const currentLang = i18n.language?.substring(0, 2) || 'es';

  const oidcConfig = useMemo(() => ({
    authority: `${auth.url}realms/${realmValue}`,
    client_id: auth.clientId,
    redirect_uri: window.location.origin + '/callback',
    post_logout_redirect_uri: window.location.origin,
    userStore: new WebStorageStateStore({
      store: window.localStorage
    }),
    extraQueryParams: {
      ui_locales: currentLang,
      kc_locale: currentLang
    }
  }), [auth, realmValue, currentLang]);

  return (
    <AuthProvider key={realmValue} {...oidcConfig}>
      <App />
    </AuthProvider>
  );
}
